export const GIFT_GUIDE_CAMPAIGN_ITEM_CLICK = 'GIFT_GUIDE_CAMPAIGN_ITEM_CLICK';

const giftGuideCampaignItemClick = item => ({
  type: GIFT_GUIDE_CAMPAIGN_ITEM_CLICK,
  item,
});

export default {
  giftGuideCampaignItemClick,
};
